import axios from 'axios';

const STATUS_CODE = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  SERVER_ERROR: 500,
};

const X_ACCESS_KEYS = {
  production: 'sk_live_foVLsGeSiTao3C6PY9xF7ETJq72jB3Up',
  default: 'sk_dev_8rvlwJ1iXWwaTISfUc0m40nhQaY9ZbqW',
};


const baseURL = '/his-api';

const instance = axios.create({
  baseURL,
  withCredentials: false,
});

instance.defaults.headers.common['Accept'] = 'text/plain';

instance.interceptors.request.use(
  (config) => {
    const xAccessKey =
      process.env.NODE_ENV === 'development'
        ? X_ACCESS_KEYS.default
        : X_ACCESS_KEYS.production;
    config.headers['x-access-key'] = xAccessKey;
    return config;
  },
  (error) => Promise.reject(error),
);
instance.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case STATUS_CODE.BAD_REQUEST:
          break;
        case STATUS_CODE.UNAUTHORIZED:
          break;
        case STATUS_CODE.FORBIDDEN:
          break;
        case STATUS_CODE.NOT_FOUND:
          break;
        case STATUS_CODE.SERVER_ERROR:
          break;
      }
      return Promise.reject(error.response);
    }
  },
);

/**
 * Service to call HTTP request via Axios (HIS External - No Auth)
 */
export default class HisApiService {
  /**
   * Send the GET HTTP request
   * @param url
   * @param config
   * @returns {*}
   */
  async get(url, config = {}) {
    try {
      let res = await instance.get(url, { ...config });
      if (res.status === 200 || res.status === 201) {
        if (config.responseType) {
          return res;
        }
        return res.data;
      }
    } catch (error) {
      if (error && error.data) {
        if (error.data.error) {
          throw error.data.error;
        }
        throw error.data;
      }
      throw 'Server không response';
    }
  }

  /**
   * Send the POST HTTP request
   * @param url
   * @param data
   * @param config
   * @returns {*}
   */
  async post(url, data, config = {}) {
    try {
      let res = await instance.post(url, data, { ...config });
      if (res.status === 200 || res.status === 201) {
        if (config.responseType) {
          return res;
        }
        return res.data;
      }
    } catch (error) {
      if (error && error.data) {
        if (error.data.error) {
          throw error.data.error;
        }
        throw error.data;
      }
      throw { code: 'unknow', message: 'Server không response' };
    }
  }

  /**
   * Send the PUT HTTP request
   * @param url
   * @param data
   * @param config
   * @returns {*}
   */
  async put(url, data, config = {}) {
    try {
      let res = await instance.put(url, data, { ...config });
      if (res.status === 200 || res.status === 201) {
        return res.data;
      }
    } catch (error) {
      if (error && error.data) {
        if (error.data.error) {
          throw error.data.error;
        }
        throw error.data;
      }
      throw { code: 'unknow', message: 'Server không response' };
    }
  }

  /**
   * Send the PATCH HTTP request
   * @param url
   * @param data
   * @param config
   * @returns {*}
   */
  async patch(url, data, config = {}) {
    try {
      let res = await instance.patch(url, data, { ...config });
      if (res.status === 200 || res.status === 201) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.error) {
          throw error.response.data.error;
        }
        throw error.response.data;
      }
      throw error.response;
    }
  }

  /**
   * Send the DELETE HTTP request
   * @param url
   * @param config
   * @returns {*}
   */
  async delete(url, config = {}) {
    try {
      let res = await instance.delete(url, { ...config });
      if (res.status === 200 || res.status === 201) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.error) {
          throw error.response.data.error;
        }
        throw error.response.data;
      }
      throw error.response;
    }
  }
}
// his call api service instance
// patientId (nếu có) được HIS ưu tiên hơn externalId — dùng khi 1 SĐT có nhiều hồ sơ
export const getLatestCheckupByPhoneInRange = (externalId, startDate, endDate, patientId = null) => {
  const hisApiService = new HisApiService();
  return hisApiService.get('/api/patpiidata/aggregate-by-phone', {
    params: { externalId, startDate, endDate, patientId: patientId ?? undefined },
  });
};

export const getLatestCheckupByPhoneBeforeDate = (externalId, date, patientId = null) => {
  const hisApiService = new HisApiService();
  return hisApiService.get('/api/patpiidata/aggregate-by-phone-before-date', {
    params: { externalId, date, patientId: patientId ?? undefined },
  });
};

export const getPatientIdsByPhone = (phone) => {
  const hisApiService = new HisApiService();
  return hisApiService.get('/api/patpiidata/patient-ids-by-phone', {
    params: { phone },
  });
};

// Danh sách hồ sơ theo SĐT kèm bệnh viện, ngày sinh, lần khám gần nhất
export const getPatientsByPhone = (phone) => {
  const hisApiService = new HisApiService();
  return hisApiService.get('/api/patpiidata/patients-by-phone', {
    params: { phone },
  });
};
